import { IzIntegrationController } from '../controller/IzIntegrationController';
import { BaseWebComponentElement } from '../../framework/BaseWebComponentElement';

export class IzIntegrationWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: IzIntegrationController,
    });
  }
}
